<template>
	<div
		class="flyout"
		ref="flyout"
		:class="{ 'active' : active, 'upsidedown' : isUpsidedown }"
		:style="`width:${width}; right:${right}; top: ${top};`"
	>
		<div class="item-container">
			<slot class="flyout-item" name="flyout-item"></slot>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		width: {
			type: String,
			default: '250px'
		},

		active: {
			type: Boolean,
			default: false
		},

		right: {
			type: String,
			default: '-50%'
		},

		top: {
			type: String,
			default: '170%'
		},

		isUpsidedown: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {

		}
	},

	mounted () {
		this.setProps()
	},

	methods: {
		setProps () {

		}
	}
}
</script>
<style lang="scss" scoped>
.flyout {
	position: absolute;
	background-color: #fff;
	width: 250px;
	pointer-events: none;
	opacity: 0;
	transition: 0.3s;
	border-top: 1px solid #d3d3d3;
	z-index: +1;

	&.active {
		pointer-events: all;
		opacity: 1;

		&::before {
			opacity: 1
		}
	}

	&.upsidedown {
		transform: rotate(180deg);
		border: none;
		border-top: 1px solid #d3d3d3;

		&::before{
			top: -6px;
		}

		.item-container {
			transform: rotate(180deg);
			border: 1px solid #d3d3d3;
			border-bottom: none;
		}
	}

	&::before{
		transition: 0.6s;
		opacity: 0;
		z-index: 1;
		position: absolute;
		background-color: #fff;
		top: -5px;
		right: 17px;
		content: '';
		padding: 5px;
		border: 1px solid #d3d3d3;
		transform: rotate(-45deg);
		pointer-events: none;
	}

	.item-container {
		z-index: +3;
		position: absolute;
		width: 100%;
		background-color: #fff;
		border: 1px solid #d3d3d3;
		border-top: none;

		.flyout-item {
			padding: 10px 15px;
			background-color: #fff;
			transition: 0.3s;
			position: relative;

			&:hover {
				color: white;
				background: #2DC4B6;
			}

			&.flyout-chervon-down {
				&::after {
					content: '';
					top: 36%;
					right: 15px;
					position: absolute;
					margin-left: 10px;
					width: 5px;
					height: 5px;
					border-right: 2px solid #A4AFB7;
					border-bottom: 2px solid #A4AFB7;
					border-top: 1px solid transparent;
					border-left: 1px solid transparent;
					-webkit-transform: rotate(45deg);
					transform: rotate(45deg);
					transition: 0.3s;
				}

				&:hover {
					&::after {
						border-right: 2px solid #fff;
						border-bottom: 2px solid #fff;
					}
				}
			}
		}
	}

}
</style>
